import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import CKALogo from '../assets/images/CKA Birla_Logo.svg';
import BirlanuLogo from '../assets/images/birlanu_water_tank_logo.svg';
import DoneIcon from '../assets/images/done.svg';
import '../styles/forgotpassword.css';


const SuccessPage = () => {
  const navigate = useNavigate();
  const handleGoToLogin = () => {
    navigate('/login');
  };
  return (
    <div className="login-wrapper">
      <div>
        <div className="login-logo">
          <img src={BirlanuLogo} alt="Birlanu Water Tank Logo" />
        </div>
        <div className="login-form">
          <div className="success-wrap">
            <div className='success-icon'>
              <img src={DoneIcon} alt="Done" style={{ width: 45, height: 45 }} />
            </div>
          </div>
          <h1>Password Set Successfully</h1>

          <h3> Your password has been set successfully. You can now access your technician account.</h3>
          <div className="form-info">


            <button type="button" className="login-btn" onClick={handleGoToLogin}>
              Go To Login
            </button>
          </div>

        </div>
      </div>
      <div className="footer-section">
        <img src={CKALogo} alt="CKA Birla Logo" />
        <div className="footer-links">
          <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
          <span>&nbsp;|&nbsp;</span>
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
        </div>
      </div>

    </div>
  );
};

export default SuccessPage;
